import React, { useEffect, useState } from "react";
import logo from "../assets/Syke.png";
import { Link } from "react-router-dom";

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [proposalCount, setProposalCount] = useState(0);

  useEffect(() => {
    const loadProposalCount = async () => {
      try {
        const response = await fetch(
          "/admin/shift-proposals?ak=iamanadminiamanadminiaasurgeon",
          {
            method: "GET",
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error("Käyntiehdotusten määrän haku epäonnistui");
        }

        const data = await response.json();
        setProposalCount(Array.isArray(data) ? data.length : 0);
      } catch (error) {
        console.error(error);
      }
    };

    loadProposalCount();

    const interval = setInterval(loadProposalCount, 10000);

    return () => clearInterval(interval);
  }, []);

  const proposalBadge =
    proposalCount > 0 ? (
      <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 ml-1 text-xs font-bold text-white bg-black rounded-full">
        {proposalCount}
      </span>
    ) : null;

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="w-full bg-primary">
      <div className="flex items-center justify-between w-full px-4 py-3 md:px-10 lg:px-36 md:h-20 md:py-0">
        <Link
          className="flex-shrink-0 text-base font-bold text-text"
          to="/koti"
          onClick={closeMenu}
        >
          <img src={logo} alt="Syke Kotipalvelut" className="w-24 md:w-28" />
        </Link>

        {/* Desktop-valikko */}
        <div className="hidden md:flex items-center justify-end gap-x-6 lg:gap-x-8 text-sm text-text whitespace-nowrap">
          <Link className="hover:text-main focus:text-main" to="/koti">
            Etusivu
          </Link>
          <Link className="hover:text-main focus:text-main" to="/luo/keikka">
            Luo keikka
          </Link>
          <Link className="hover:text-main focus:text-main" to="/tyontekijat">
            Työntekijät
          </Link>
          <Link
            className="hover:text-main focus:text-main"
            to="/kayntiehdotukset"
          >
            <span className="inline-flex items-center">
              Käyntiehdotukset
              {proposalBadge}
            </span>
          </Link>
          <Link className="hover:text-main focus:text-main" to="/hallitse">
            Hallitse
          </Link>
        </div>

        {/* Mobiilin valikkopainike */}
        <button
          type="button"
          className="md:hidden flex items-center gap-2 px-3 py-2 text-sm font-medium text-text"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-label="Avaa tai sulje valikko"
        >
          <span className="text-xl leading-none">☰</span>
          Valikko
        </button>
      </div>

      {/* Mobiilivalikko */}
      {menuOpen && (
        <div className="md:hidden flex flex-col w-full px-4 pb-4 text-sm text-text">
          <Link
            className="py-3 border-t border-white/20 hover:text-main focus:text-main"
            to="/koti"
            onClick={closeMenu}
          >
            Etusivu
          </Link>

          <Link
            className="py-3 border-t border-white/20 hover:text-main focus:text-main"
            to="/luo/keikka"
            onClick={closeMenu}
          >
            Luo keikka
          </Link>

          <Link
            className="py-3 border-t border-white/20 hover:text-main focus:text-main"
            to="/tyontekijat"
            onClick={closeMenu}
          >
            Työntekijät
          </Link>

          <Link
            className="py-3 border-t border-white/20 hover:text-main focus:text-main"
            to="/kayntiehdotukset"
            onClick={closeMenu}
          >
            <span className="inline-flex items-center">
              Käyntiehdotukset
              {proposalBadge}
            </span>
          </Link>

          <Link
            className="py-3 border-t border-b border-white/20 hover:text-main focus:text-main"
            to="/hallitse"
            onClick={closeMenu}
          >
            Hallitse
          </Link>
        </div>
      )}
    </nav>
  );
}

export default NavBar;
